import { c as _c } from "react/compiler-runtime";
import type { KeyWith } from '@/lib/piano/keyboard';
import type { TouchWeightAnalyzedKeyboard } from '@/lib/piano/touch-design/touch-weight-key-analysis';
import { useCallback } from 'react';

/** A target, key by key: only its values matter to the design. */
interface KeyedTarget {
  data: readonly KeyWith<number | undefined>[];
}
interface GenerateDesignedKeyboardFromSeriesProps {
  frontWeightTargetSerie: KeyedTarget;
  strikeWeightTargetSerie: KeyedTarget;
  strikeWeightRatioTargetSerie: KeyedTarget;
  supportSpringBalanceWeightTargetSerie: KeyedTarget;
}
export const useGenerateDesignedKeyboardFromSeries = analyzedKeyboard => {
  const $ = _c(4);
  let t0;
  if ($[0] !== analyzedKeyboard) {
    t0 = props => analyzedKeyboard.map(key => {
      const keyIndex = key.number - 1;
      return {
        ...key.payload,
        frontWeight: props.frontWeightTargetSerie?.data[keyIndex]?.payload ?? null,
        strikeWeight: props.strikeWeightTargetSerie?.data[keyIndex]?.payload ?? null,
        strikeWeightRatio: props.strikeWeightRatioTargetSerie?.data[keyIndex]?.payload ?? null,
        supportSpringBalanceWeight: props.supportSpringBalanceWeightTargetSerie?.data[keyIndex]?.payload ?? null
      };
    });
    $[0] = analyzedKeyboard;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const generateDesignedKeyboardFromSeries = t0;
  let t1;
  if ($[2] !== generateDesignedKeyboardFromSeries) {
    t1 = {
      generateDesignedKeyboardFromSeries
    };
    $[2] = generateDesignedKeyboardFromSeries;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};